import { createRootRoute, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { Suspense } from "react";
import NavigationLoading from "@/src/presentation/components/navigation-loading";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <NavigationLoading />
      <Suspense
        fallback={
          <div className="flex h-screen w-screen items-center justify-center">
            <div className="size-16 animate-spin rounded-full border-8 border-dashed border-brand-accent" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
      {import.meta.env.DEV && <TanStackRouterDevtools />}
    </>
  );
}
